export default {
  "en": {
    "upsell": {
      "contact_us": "Interested? Contact Us!",
      "decisions_partners": {
        "guidance": "Decision partners can create and/or manage proposals if given permission <br>You can read more about decision partners <a class='is-underlined' href='/help/content/partners/partners.html#decision-partners' target='_blank'>here</a>",
        "intercom": "Hello Ziggu! I'm interested in the Decision Partners feature. Can you provide some more information? Kind regards, %{name}"
      },
      "decisions_reminders": {
        "guidance": "Reminders allow you to automatically notify customers there are proposals waiting for a decision.<br>You can read more about reminders <a class='is-underlined' href='/help/content/decisions/decisions.html?#step-3-optional-settings' target='_blank'>here</a>",
        "intercom": "Hello Ziggu! I'm interested in the Reminders feature. Can you provide some more information? Kind regards, %{name}"
      },
      "integration_aircall": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Aircall. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Aircall",
          "title_sub": "Push contacts to Aircall or log calls in Ziggu"
        }
      },
      "integration_archisnapper": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Archisnapper. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Archisnapper",
          "title_sub": "Push your Archisnapper checklists to Ziggu"
        }
      },
      "integration_astena": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Astena. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Astena",
          "title_sub": "Push your installments, invoices and other financial data Ziggu"
        }
      },
      "integration_bouwsoft": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Bouwsoft. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Bouwsoft",
          "title_sub": "Push your Bouwsoft contacts, units and installments to Ziggu"
        }
      },
      "integration_bricsys": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Bricsys. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Bricsys",
          "title_sub": "Push your Bricsys documents to Ziggu"
        }
      },
      "integration_exact_online": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Exact Online. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Exact Online",
          "title_sub": "Push your Exact Online installments, invoices and other financial data  to Ziggu"
        }
      },
      "integration_hubspot": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Hubspot. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Hubspot",
          "title_sub": "Push your Hubspot contacts, units and documents to Ziggu"
        }
      },
      "integration_kpd": {
        "intercom": "Hello Ziggu! I'm interested in the integration with KPD. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "KPD",
          "title_sub": "Push your installments, invoices and other financial data to Ziggu"
        }
      },
      "integration_letsbuild": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Letsbuild. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Letsbuild",
          "title_sub": "Push your Letsbuild points to Ziggu"
        }
      },
      "integration_navision": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Microsoft Dynamics Navision. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Microsoft Dynamics Navision",
          "title_sub": "Push your contacts, installments, invoices and other financial data to Ziggu"
        }
      },
      "integration_power_bi": {
        "intercom": "Hello Ziggu! I'm interested in the integration with PowerBI. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "PowerBI",
          "title_sub": "Push your PowerBI statistics and other data to Ziggu"
        }
      },
      "integration_realpad": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Realpad. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Realpad",
          "title_sub": "Push your contacts to Ziggu"
        }
      },
      "integration_salesforce": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Salesforce. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Salesforce",
          "title_sub": "Push your Salesforce contacts, units, documents and installments to Ziggu"
        }
      },
      "integration_sap": {
        "intercom": "Hello Ziggu! I'm interested in the integration with SAP. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "SAP",
          "title_sub": "Push your contacts, installments, invoices and other financial data to Ziggu"
        }
      },
      "integration_sharepoint": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Sharepoint. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Sharepoint",
          "title_sub": "Push your documents to Ziggu"
        }
      },
      "integration_teamleader": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Teamleader. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Teamleader",
          "title_sub": "Push your contacts, installments, invoices and other financial data to Ziggu"
        }
      },
      "integration_yuki": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Yuki. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Yuki",
          "title_sub": "Push your installments, invoices and other financial data to Ziggu"
        }
      },
      "integration_zoho": {
        "intercom": "Hello Ziggu! I'm interested in the integration with Zoho. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Zoho",
          "title_sub": "Push your Zoho contacts, units, documents and installments to Ziggu"
        }
      },
      "marketplace": {
        "category": {
          "feature": "Feature",
          "integration": "Integration"
        }
      },
      "not_included": "💡 Interested in this feature? 💡",
      "project_email_forwarding": {
        "cta": "Forward emails to {project_name}",
        "description": "Allow everybody within your team to forward emails directly to you Ziggu projects.",
        "intercom": "Hello Ziggu! I'm interested in the Project email forwarding feature. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Project email forwarding",
          "title_sub": "Forward emails directly to you Ziggu projects."
        },
        "title": "New! Email forwarding within projects",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Yes, you can contact me for this!",
        "cta": "Improve your project branding?",
        "description": "Personalised project url and login screen <br/> Dedicated project environment when logged in <br/> Project branded emails <br/> Makes working with other real estate developers on the same project easier",
        "intercom": "Hello Ziggu! I'm interested in the Project Experience module. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Project experience",
          "title_sub": "Improve your project branding with a personalised project url and environment"
        },
        "title": "Make your customers feel at home with the new Project Experience!",
        "youtube_id": "f26cNo2rwWE"
      },
      "proposal_choice_lists": {
        "guidance": "Choice lists allow you to let customers make choices inside proposals.<br>You can read more about choice lists <a class='is-underlined' href='/help/content/decisions/decisions.html#choice-list' target='_blank'>here</a>",
        "intercom": "Hello Ziggu! I'm interested in the Choice Lists feature. Can you provide some more information? Kind regards, %{name}"
      },
      "signatures": {
        "cta_text": "Need signatures for your documents? Contact us",
        "guidance": "Signatures allow you to let customers sign important documents digitally.<br>You can read more about signatures <a class='is-underlined' href='/help/content/decisions/decisions.html#electronic-signature' target='_blank'>here</a>",
        "intercom": "Hello Ziggu! I'm interested in the Signatures feature. Can you provide some more information? Kind regards, %{name}"
      }
    }
  }
}